// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3vI1F","name":"ConsentHeader_name__1GpWZ","birthday":"ConsentHeader_birthday__22W1r","skeleton":"ConsentHeader_skeleton__Cup6x"};